module.exports = __webpack_public_path__ + "static/media/html-css.db6ff7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/html-css.png
// module id = 613
// module chunks = 146